var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./gallery-featured.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-56335d10\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./gallery-featured.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/gallery/components/gallery-featured/gallery-featured.vue
// module id = 254
// module chunks = 0